import db from '../../db';
import { SET_SEARCH_HISTORY, EQUIPMENT_CODE, LIQUID_BOTTLE_CODE } from './searchHistoryConstants'

function setSearchHistoryAction(searchHistory) {
    return {
        searchHistory,
        type: SET_SEARCH_HISTORY,
    }
}

export function getSearchHistoryTypes() {
    return [
        {
            id: 0,
            code: EQUIPMENT_CODE,
            name: "Equipement",
        }, {
            id: 1,
            code: LIQUID_BOTTLE_CODE,
            name: "Bouteille de fluide"
        }
    ]
}

export function getSearchHistoryType(code) {
    let historyType = getSearchHistoryTypes().find((historyType) => historyType.code === code)
    return historyType || {}
}

export function getSearchHistoryLines(type = null) {
    return async (dispatch) => {

        let historyLines;

        if (type)
            historyLines = await db.SearchHistory.where('type').equals(type.id);
        else
            historyLines = await db.SearchHistory;

        await historyLines.reverse().toArray((history) => {
            dispatch(setSearchHistoryAction(history))
        });
    }
}

export function removeSearchHistoryLine(type, historyLine) {
    return (dispatch) => {
        db.SearchHistory.delete(historyLine.id);
        dispatch(getSearchHistoryLines(type));
    }
}

export function addSearchHistoryLine(type, searchInput) {
    return (dispatch) => {
        if (!searchInput || searchInput.length > 20)
            return;

        db.transaction("rw?", db.SearchHistory, async () => {

            let historyLines = await db.SearchHistory.where('type').equals(type.id);

            if (await historyLines.filter((historyLine) => historyLine.searchInput === searchInput).count() > 0)
                return;

            //J'ajoute ma nouvelle ligne d'historique
            db.SearchHistory.add({
                type: type.id,
                searchInput: searchInput,
            });

            historyLines = await db.SearchHistory.where('type').equals(type.id);

            //Purge pour n'avoir que les 30 dernières recherches pour chaque type
            if (await historyLines.count() > 30) {
                historyLines.first().then((olderHistoryLine) => {
                    db.SearchHistory.delete(olderHistoryLine.id);
                });
            }

            //Je mets à jour ma liste de lignes d'historique via mon dispatcher
            dispatch(getSearchHistoryLines(type));
        })
    }
}
